export BASE_PATH := "https://danielx.net/composer/"
// Content-addressed publishing (infra/lib/composer-publish-stack.ts): the body
// is stored under its sha, which comes back, and data.danielx.net serves it.
export PUBLISH_URL := "https://svc.danielx.net/composer/publish"
export CLEF_OFFSET := 256
export CUSTOM_PRESET_NAME := "custom"
export DEFAULT_SPRITE_SHA := "9HL1JO7vtHRBkHJ8rkb0FqfAVjikXYs6I4Z4xiMsHDs"
export DEFAULT_SYNTH_SHA := "ujwLwBnzFSVrrjlCVJ2KvVJxO-n6YahfEQ82ikcFSjw"
export LEGACY_SYNTH_SHA := "ADie7JCdxXfNn8qgnIj7eE9dFtFO6_aAUa9gcZ6lsEM"
// GeneralUser GS v2.0.3, shipped in app/assets/composer/sf/. The General MIDI bank
// imported songs play through; see that directory's LICENSES.md for its terms.
export GENERAL_USER_GS_SHA := "lXUCjHofWJ9XcPzMjP8nNFZq9AzSbtg2lE6aUVJojP4"
export FFT_SIZE := 1024
// The waveform-only analysers (stereoAnalyser in lib/fx.civet): four spectrum lengths.
export SCOPE_FFT_SIZE := 4096
export PIXELS_PER_BEAT := 96
export SAMPLE_RATE := 48000
export SPRITE_SIZE := 48
export THEME_KEY := "paint-composer/theme"
export VIEW_KEY := "paint-composer/view"
export MODE_VIEWS_KEY := "paint-composer/mode-views"
export LESSONS_KEY := "paint-composer/lessons"

// Both rolls' dark field; a song theme can override it (rollBackground)
export ROLL_BG_COLOR := 0x1B1B2A

// Practice/game judgment feedback, shared by the staff and piano-roll overlays
export JUDGMENT_FEEDBACK_MS := 700
// Defaults — the views read player.practiceJudgmentColors(), which lays the
// song theme's judgmentColors over these
export JUDGMENT_COLORS: Record<string, number> :=
  perfect: 0x00E676
  good: 0x9CCC65
  early: 0xFFC107
  late: 0xFF9800
  wrong: 0xFF1744
  miss: 0x90A4AE

// Game HUD palette (game-hud-layer.civet). Multiplier tiers heat up through
// the chip neon palette, indexed by tier (×1..×4); health runs green →
// amber → red as it drains. The one home for these colors.
export HUD_TIER_COLORS := [0xFFFFFF, 0xFFFFFF, 0x4ECDC4, 0xFFD166, 0xFF6B81]
export HUD_HEALTH_COLORS := { high: 0x00E676, mid: 0xFFC107, low: 0xFF1744 }

// Fingering labels, tinted per hand in both views
export FINGERING_COLORS: Record<string, number> :=
  L: 0x1E88E5 // left hand blue
  R: 0xF4511E // right hand orange

export JUDGMENT_LABELS: Record<string, string> :=
  perfect: "Perfect"
  good: "Good"
  early: "Early"
  late: "Late"
  wrong: "✕"
  miss: "Miss"

// Per-channel note colors, shared by the staff view's duration bars and the
// piano-roll view's falling notes
export CHANNEL_COLORS := [
  0xCBDBFC
  0xEEC39A
  0xDF7126
  0x4B692F
  0xFBF236
  0x847E87
  0xFBF236
  0x5B6EE1
  0xFBF236
  0xD95763
  0xFFFFFF
  0xCBDBFC
  0xFBF236
  0xEEC39A
  0x5FCDE4
  0xD77BBA
  0xFFFFFF
  0x663931
  0xAC3232
  0xD77BBA
  0x847E87
]
export US_PER_S := 1000000
